import type { SessionsPresenter } from '@carboncopyco/data';
import {
  Avatar,
  TextBase,
  TooltipBubble,
  stringToColor,
} from '@carboncopyco/ui';
import { integersFormatter } from '@carboncopyco/utils';
import classNames from 'classnames';
import type { Col } from '../../../../FixedTable';

export const getCols = (isInModal?: boolean): Col<SessionsPresenter>[] => [
  {
    alignment: 'left',
    title: 'Presenter name',
    width: isInModal ? 550 : 250,
    maxContentWidth: isInModal ? 520 : 220,
    render: (presenter) => {
      const name = presenter?.name ?? 'Anonymous';
      return (
        <div className="flex items-center gap-1.5 ">
          <div className="w-min">
            <Avatar
              backgroundColor={stringToColor(presenter.name)}
              image={presenter.image}
              size="small"
              initials={name
                .split(' ')
                .map((word) => word.charAt(0))
                .join('')}
            />
          </div>
          <TooltipBubble
            placement="top-start"
            title={name}
          >
            <div
              className={classNames(
                'truncate',
                isInModal ? 'max-w-[500px]' : 'max-w-[180px]'
              )}
            >
              <TextBase
                label={name}
                color="text-ds-natural-600"
                ellipsis
              />
            </div>
          </TooltipBubble>
        </div>
      );
    },
  },
  {
    alignment: isInModal ? 'center' : 'right',
    title: 'Sessions',
    width: isInModal ? 100 : 60,
    render: (presenter) => {
      const sessions = integersFormatter(presenter.occurrences);
      return (
        <TextBase
          label={sessions}
          color="text-ds-natural-600"
        />
      );
    },
  },
];
